// DateFormatUtility.ts
export const formatDateForDisplay = (dateString: string): string => {
  if (!dateString) return '';
  
  // If already in MM-DD-YYYY format, return as is
  if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
    return dateString;
  }
  
  // Convert from YYYY-MM-DD to MM-DD-YYYY
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split('-');
    return `${month}-${day}-${year}`;
  }
  
  // Try parsing other formats
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }
  
  return dateString;
};

export const formatDateForAPI = (dateString: string): string => {
  if (!dateString) return '';
  
  // Convert from MM-DD-YYYY to YYYY-MM-DD for API
  if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
    const [month, day, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
  }
  
  return dateString;
};

// Validate MM-DD-YYYY format
export const isValidDate = (dateString: string): boolean => {
  return /^\d{2}-\d{2}-\d{4}$/.test(dateString);
};

// // DateFormatUtility.ts

// // Convert from MM-DD-YYYY to YYYY-MM-DD for date input
// export const formatDateForDateInput = (dateString: string): string => {
//   if (!dateString) return '';
  
//   // If already in YYYY-MM-DD format, return as is
//   if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//     return dateString;
//   }
  
//   // Convert from MM-DD-YYYY to YYYY-MM-DD
//   if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
//     const [month, day, year] = dateString.split('-');
//     return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//   }
  
//   // Try parsing other formats
//   const date = new Date(dateString);
//   if (!isNaN(date.getTime())) {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   }
  
//   return dateString;
// };

// // Convert from YYYY-MM-DD (date input) to MM-DD-YYYY (storage format)
// export const formatDateFromDateInput = (dateString: string): string => {
//   if (!dateString) return '';
  
//   // Convert from YYYY-MM-DD to MM-DD-YYYY
//   if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//     const [year, month, day] = dateString.split('-');
//     return `${month}-${day}-${year}`;
//   }
  
//   return dateString;
// };

// // Format date for display (MM-DD-YYYY)
// export const formatDateForDisplay = (dateString: string): string => {
//   if (!dateString) return '';
  
//   // If already in MM-DD-YYYY format, return as is
//   if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
//     return dateString;
//   }
  
//   // Convert from YYYY-MM-DD to MM-DD-YYYY
//   if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//     const [year, month, day] = dateString.split('-');
//     return `${month}-${day}-${year}`;
//   }
  
//   // Try parsing other formats
//   const date = new Date(dateString);
//   if (!isNaN(date.getTime())) {
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const year = date.getFullYear();
//     return `${month}-${day}-${year}`;
//   }
  
//   return dateString;
// };

// // Existing functions (keep these)
// export const formatDateForInput = (dateString: string): string => {
//   return formatDateForDisplay(dateString); // Now uses the same logic
// };

// export const formatDateForAPI = (dateString: string): string => {
//   if (!dateString) return '';
  
//   // Convert from MM-DD-YYYY to YYYY-MM-DD for API
//   if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
//     const [month, day, year] = dateString.split('-');
//     return `${year}-${month}-${day}`;
//   }
  
//   return dateString;
// };

// // // Date format utility functions
// // export const formatDateForInput = (dateString: string): string => {
// //   if (!dateString) return '';
  
// //   // If already in mm-dd-yyyy format, return as is
// //   if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
// //     return dateString;
// //   }
  
// //   // Convert from yyyy-mm-dd to mm-dd-yyyy
// //   if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
// //     const [year, month, day] = dateString.split('-');
// //     return `${month}-${day}-${year}`;
// //   }
  
// //   // Try parsing other formats
// //   const date = new Date(dateString);
// //   if (!isNaN(date.getTime())) {
// //     const month = String(date.getMonth() + 1).padStart(2, '0');
// //     const day = String(date.getDate()).padStart(2, '0');
// //     const year = date.getFullYear();
// //     return `${month}-${day}-${year}`;
// //   }
  
// //   return dateString;
// // };

// // export const formatDateForAPI = (dateString: string): string => {
// //   if (!dateString) return '';
  
// //   // Convert from mm-dd-yyyy to yyyy-mm-dd for API
// //   if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
// //     const [month, day, year] = dateString.split('-');
// //     return `${year}-${month}-${day}`;
// //   }
  
// //   return dateString;
// // };